"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalRule = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const color_1 = require("../constants/color");
const utils_1 = require("../utils");
const styled_system_1 = require("../utils/styled-system");
exports.HorizontalRule = styled_1.default.hr((props) => ({
    ...(0, styled_system_1.opacity)(props),
    border: 'none',
    borderTop: `1px solid ${props.color ?? color_1.Color.GREY}`,
    height: 0,
    margin: 0,
    paddingBottom: props.padded ? 32 : undefined,
    paddingTop: props.padded ? 32 : undefined,
    width: '100%',
    ...(0, styled_system_1.space)(props),
    ...(0, utils_1.createStyles)(props.styles),
}));
